var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, IconButton, styled, TextField, Typography } from '@mui/material';
import { ThumbsDownIcon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { X } from 'react-feather';
import { Controller, useForm } from 'react-hook-form';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { useDislikeAnswerMutation } from '../../../../../application/features/chat/chat-api';
import { useAppSelector } from '../../../../../application/store/useStore';
import useTranslate from '../../../../../localization/helpers';
import TextEditor from '../../../../components/TextEditor';
var MessageBox = styled(Box)(function () { return ({
    position: 'relative',
    maxWidth: '85%',
    backgroundColor: '#FFFFFF',
    padding: '10px',
    borderRadius: '10px',
    boxShadow: '0 24px 48px 0 #919EAB29',
    display: 'flex',
    flexDirection: 'column'
}); });
var ChatFeedback = function (_a) {
    var _b;
    var isOpen = _a.isOpen, onClose = _a.onClose, dislikedMessage = _a.dislikedMessage;
    var _c = useTranslate(), translate = _c.translate, tWithField = _c.tWithField;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var conversation_id = useAppSelector(function (state) { return state.chat; }).conversation_id;
    var _d = __read(useDislikeAnswerMutation(), 2), dislikeAnswer = _d[0], _e = _d[1], isLoading = _e.isLoading, isSuccess = _e.isSuccess;
    var _f = useForm({
        defaultValues: {
            userId: '',
            conversationId: '',
            messageId: '',
            suggestedResponse: '',
            moreDetails: ''
        }
    }), control = _f.control, register = _f.register, handleSubmit = _f.handleSubmit, reset = _f.reset, errors = _f.formState.errors;
    useEffect(function () {
        if (dislikedMessage && currentUser && conversation_id) {
            reset({
                userId: currentUser.userId,
                messageId: dislikedMessage.message_id,
                conversationId: conversation_id
            });
        }
    }, [conversation_id, currentUser, dislikedMessage, reset]);
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.submitSuccess', 'common.feedback'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            closeChatFeedback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var onSubmit = function (feedback) { return dislikeAnswer(feedback); };
    var closeChatFeedback = function () {
        reset();
        onClose();
    };
    var validateSuggestedResponse = function (value) {
        var _a;
        var div = document.createElement('div');
        div.innerHTML = value;
        var isEmpty = !((_a = div.textContent) === null || _a === void 0 ? void 0 : _a.trim());
        return !isEmpty || tWithField('validations.fieldIsRequired', 'chat.suggestedResponse');
    };
    return (_jsxs(Dialog, { fullWidth: true, scroll: 'paper', onClose: closeChatFeedback, open: isOpen, maxWidth: 'sm', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [translate('chat.chatFeedback'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: closeChatFeedback, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsxs(DialogContent, { children: [_jsx(Box, { display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2, maxWidth: '100%', children: _jsx(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', children: _jsxs(Box, { marginTop: 2, display: 'flex', flexDirection: 'column', width: '100%', position: 'relative', children: [_jsxs(MessageBox, { sx: { maxWidth: '100%', position: 'relative' }, children: [_jsx(IconButton, { style: {
                                                    backgroundColor: '#FFE9D5',
                                                    borderRadius: '100px',
                                                    width: '28px',
                                                    height: '28px',
                                                    top: -13,
                                                    right: -11,
                                                    cursor: 'default',
                                                    position: 'absolute'
                                                }, size: 'small', children: _jsx(ThumbsDownIcon, { color: '#FF5630', size: '16px' }) }), _jsx(Typography, { variant: 'body2', children: _jsx("span", { className: 'reactMarkDown', children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], rehypePlugins: [rehypeRaw], children: dislikedMessage.answer }) }) })] }), _jsxs(Typography, { variant: 'caption', display: 'block', align: 'right', paddingTop: 0.5, color: 'textSecondary', children: [_jsx("span", { children: new Date(dislikedMessage.time).toLocaleDateString(translate('common.dateLanguageCode1'), {
                                                    month: 'short',
                                                    day: 'numeric',
                                                    year: 'numeric'
                                                }) }), _jsx("span", { children: " - " }), _jsx("span", { children: new Date(dislikedMessage.time).toLocaleTimeString(translate('common.dateLanguageCode2'), {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                }) })] })] }) }) }), _jsx(Box, { display: 'flex', children: _jsx(Typography, { variant: 'body2', children: translate('chat.chatFeedbackText') }) }), _jsx(Box, { width: '100%', marginTop: 2, children: _jsx(Controller, { control: control, name: 'suggestedResponse', rules: {
                                required: {
                                    value: true,
                                    message: tWithField('validations.fieldIsRequired', 'chat.suggestedResponse')
                                },
                                validate: validateSuggestedResponse
                            }, render: function (_a) {
                                var _b;
                                var _c = _a.field, value = _c.value, onChange = _c.onChange;
                                return (_jsxs(FormControl, { fullWidth: true, children: [_jsx(TextEditor, { value: value !== null && value !== void 0 ? value : '', onChange: onChange, placeholder: translate('chat.suggestedResponse') }), _jsx(FormHelperText, { error: true, children: (_b = errors.suggestedResponse) === null || _b === void 0 ? void 0 : _b.message })] }));
                            } }) }), _jsx(Box, { width: '100%', marginTop: 2, children: _jsxs(FormControl, { fullWidth: true, children: [_jsx(TextField, __assign({}, register('moreDetails', {
                                    required: {
                                        value: true,
                                        message: tWithField('validations.fieldIsRequired', 'chat.moreDetails')
                                    }
                                }), { error: !!errors.moreDetails, fullWidth: true, multiline: true, minRows: 4, label: translate('chat.moreDetails'), slotProps: { input: { sx: { borderRadius: '8px' } } } })), _jsx(FormHelperText, { error: true, children: (_b = errors.moreDetails) === null || _b === void 0 ? void 0 : _b.message })] }) })] }), _jsxs(DialogActions, { children: [_jsx(Button, { disabled: isLoading, onClick: closeChatFeedback, variant: 'outlined', sx: {
                            fontSize: '16px',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '16px',
                            border: '1px solid #919EAB52',
                            color: '#161C24',
                            '&:hover': {
                                backgroundColor: '#FFFFFF',
                                color: '#161C24',
                                '& .MuiSvgIcon-root': {
                                    color: '#161C24'
                                }
                            },
                            '& .MuiSvgIcon-root': {
                                color: '#161C24'
                            }
                        }, children: translate('actions.cancel') }), _jsx(Button, { disabled: isLoading, onClick: handleSubmit(onSubmit), sx: {
                            fontSize: '16px',
                            backgroundColor: '#212B36',
                            borderRadius: '16px',
                            border: '1px solid #212B36',
                            color: '#FFFFFF',
                            '&:hover': {
                                backgroundColor: '#212B36',
                                color: '#FFFFFF',
                                '& .MuiSvgIcon-root': {
                                    color: '#FFFFFF'
                                }
                            },
                            '& .MuiSvgIcon-root': {
                                color: '#FFFFFF'
                            }
                        }, variant: 'outlined', children: translate('actions.submit') })] })] }));
};
export default ChatFeedback;
